import { getLegalEntity } from '@cemex/cmx-client-layout';
import { createSelector } from '@ngrx/store';
import { getRmsRecipeSpecifications, getRmsSpecificationPage } from './index';

export const getContractsState = createSelector(getRmsSpecificationPage, state => state.contractsLegacyState);
export const getContractsOpenPlatformState = createSelector(
  getRmsSpecificationPage,
  state => state.contractsOpenPlatformState,
);

export const getAvailableContracts = createSelector(getContractsState, state => state.availableContracts);
export const getOpenPlatformContracts = createSelector(
  getContractsOpenPlatformState,
  state => state.availableContracts,
);

export const getContractsBalance = createSelector(getContractsState, state => state.balanceCompleted);
export const getOpenPlatformContractsBalance = createSelector(
  getContractsOpenPlatformState,
  state => state.balanceCompleted,
);

export const getContractData = createSelector(
  getAvailableContracts,
  getContractsBalance,
  getLegalEntity,
  (availableContract, contractbalance, customer) => {
    return {
      availableContract,
      contractbalance,
      customer,
    };
  },
);
export const getOpenPlatformContractData = createSelector(
  getOpenPlatformContracts,
  getOpenPlatformContractsBalance,
  getLegalEntity,
  (availableContract, contractbalance, customer) => {
    return {
      availableContract,
      contractbalance,
      customer,
    };
  },
);

export const getOpenPlatformContractDataRepeat = createSelector(
  getOpenPlatformContracts,
  getOpenPlatformContractsBalance,
  getLegalEntity,
  getRmsRecipeSpecifications,
  (availableContract, contractbalance, customer, recipes) => {
    return {
      availableContract,
      contractbalance,
      customer,
      recipes,
    };
  },
);

export const getAvailablePaymentTerms = createSelector(getContractsState, state => state.availablePaymentTerms);
export const getOpenPlatformAvailablePaymentTerms = createSelector(
  getContractsOpenPlatformState,
  state => state.availablePaymentTerms,
);
